import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=730a8b47&scoped=true&"
import script from "./Step4.vue?vue&type=script&lang=js&"
export * from "./Step4.vue?vue&type=script&lang=js&"
import style0 from "./Step4.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Step4.vue?vue&type=style&index=1&id=730a8b47&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730a8b47",
  null
  
)

export default component.exports